export enum GuardarianModalSteps {
  INFO,
  FORM,
  PROGRESS,
  TIMEOUT,
  FAILED,
  SUCCESS,
}
